import React from 'react';

const counters = new Map<string, number>();

function nextId(prefix: string) {
  const next = (counters.get(prefix) ?? 0) + 1;
  counters.set(prefix, next);

  return `${prefix}-${next}`;
}

export function useAutoIncrementId(prefix: string) {
  const [id] = React.useState(() => nextId(prefix));

  return id;
}
